import React from 'react';
import { Typography } from "../../ecosystem";

const VideoVisitRoomClosed = (props) => {

    return (<div className="video-visit-room-closed">
        <Typography type="body-01" color="$color-primary-a2" textAlign="center" tag="div">
            This visit is no longer available. Please schedule another appointment.
        </Typography>
    </div>);
}

export default VideoVisitRoomClosed;
